import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from '../hooks/useAuth'

/**
 * Auth guard component that redirects to login if not authenticated.
 *
 * CRITICAL: Always handle loading state before checking user to avoid
 * flash of login page during auth check.
 */
export function ProtectedRoute() {
  const { user, loading, authError } = useAuth()

  // Show loading state while checking auth
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-gray-500">Loading...</div>
      </div>
    )
  }

  // Show error state if auth initialization failed
  if (authError) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <p className="text-rose-400 mb-2">Authentication error: {authError}</p>
          <button
            onClick={() => window.location.reload()}
            className="text-sm text-foreground-muted hover:text-foreground underline"
          >
            Try again
          </button>
        </div>
      </div>
    )
  }

  // Redirect to login if not authenticated
  // `replace` prevents back-button returning to protected route
  if (!user) {
    return <Navigate to="/login" replace />
  }

  // Render child routes
  return <Outlet />
}
